import { render, staticRenderFns } from "./CustListView.vue?vue&type=template&id=7a923d24&scoped=true"
import script from "./CustListView.vue?vue&type=script&lang=js"
export * from "./CustListView.vue?vue&type=script&lang=js"
import style0 from "./CustListView.vue?vue&type=style&index=0&id=7a923d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a923d24",
  null
  
)

export default component.exports